import { FaIcon, faMagnifyingGlassSolid } from '@/lib/fa'
import React from 'react'

const ScheduleContextMenuSearchBar = ({ searchQuery, setSearchQuery }) => {
  return (
    <div className="tw-relative tw-mb-2 tw-mt-1 focus:tw-ring-2 focus:tw-ring-primary">
      <FaIcon
        icon={faMagnifyingGlassSolid}
        className="tw-text-content-muted tw-absolute tw-left-3 tw-top-1/2 tw-h-4 tw-w-4 tw--translate-y-1/2"
      />
      <input
        type="text"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        placeholder="Wyszukaj typ dnia..."
        className="placeholder:tw-text-content-muted tw-w-full tw-rounded-md tw-border tw-border-base-300 tw-bg-white tw-py-2 tw-pl-10 tw-pr-3 tw-text-sm tw-text-content-base focus:tw-border-primary focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-primary"
      />
    </div>
  )
}

export default ScheduleContextMenuSearchBar
